import { DOMAINS_FETCH_SUCCESS, EMAIL_ACTIVATION_SUCCESS } from '../constant/actionType';

const initialState = {
  domains: [],
  success: false
};

const emailActivationReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOMAINS_FETCH_SUCCESS:
      return {
        ...state,
        domains: action.data
      };
    case EMAIL_ACTIVATION_SUCCESS:
      return {
        ...state,
        success: action.data
      };

    default:
      return state;
  }
};

export default emailActivationReducer;
